// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/scroll-to-top';
import { StyledChart } from './components/chart';
import { basename } from './configs/EnvironmentConfig';

import './App.css'
import { useEffect, useState } from 'react';
import SteLib from './lib/stelib';
import moment from 'moment';

// ----------------------------------------------------------------------

export default function App() {

  const [firstTime, setFirstTime] = useState(true);
  const [settings, setSettings] = useState({holiday: undefined});
  const [htmlPage, setHtmlPage] = useState(<></>);

  useEffect(() => {
    if(firstTime)
    {
      SteLib.SimpleGet(basename+"/settings.json?timestamp="+moment().valueOf()).then((data) => {
        setSettings(data);
        SteLib.SimpleGet(basename+"/holiday.html", true).then((html) => {
          setHtmlPage(html);
        })
      })
    }
    setFirstTime(false);
  }, [firstTime]);

  return (
    <ThemeProvider>
      <ScrollToTop />
      <StyledChart />
      {settings.holiday === undefined ? <></> : settings.holiday ? 
      <div dangerouslySetInnerHTML={{ __html: htmlPage }} /> : 
      <Router basename={basename} />}
    </ThemeProvider>
  );
}
